<template>
  <section class="pb2 pt1 subtle grid grid-columns-3_sm grid-columns-1_lg align-content-start p0">
    <div class="px1 grid-column-start-1 grid-column-end-3_sm grid-column-end-2_lg">
      <h2>Red flags</h2>
      <p class="font-size-2 measure">Red flags indicate probable risk on your project. The impact distribution chart shows how much the selected red flags affect certain roles or phases assigned within your&nbsp;estimate.</p>
    </div>
    <template v-if="redFlags.length">
      <app-red-flag-chart
        :class="'order-1_sm order-0_lg align-content-start grid-column-start-3_sm grid-column-start-1_lg grid-row-start-1_sm grid-row-end-3_sm grid-row-start-2_lg'"
        :page="page"/>
      <div class="px1 grid-column-span-2_sm grid-column-span-1_lg ">
        <lw-table
          v-if="estimate.redFlags"
          :type="'lined'">
          <tr
            v-for="(flag, key) in estimate.redFlags"
            :key="key">
            <td><router-link :to="{ name: 'redflag', params: { id: key } }">{{ redFlag(key) }}</router-link></td>
          </tr>
        </lw-table>
        <button
          class="accent-button"
          @click="manageRedFlags">Manage red flags</button>
      </div>
    </template>
    <div
      v-else
      class="px1">
      <h3>You don&rsquo;t have any red flags</h3>
      <p class="font-size-2">Red flags increase the accuracy of your estimate by reducing the range and adjusting your target based on the project risks you observe.</p>
      <button
        class="accent-button"
        @click.prevent="manageRedFlags">Manage red flags</button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Table from '../livewires/Table'
import RedFlagChart from './RedFlagChart'

export default {
  components: {
    lwTable: Table,
    appRedFlagChart: RedFlagChart
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flags: []
    }
  },
  computed: {
    ...mapGetters([
      'redFlags'
    ]),
    estimate () {
      return this.$store.getters.estimate(this.page)
    }
  },
  watch: {
    estimate (value) {
      if (value.redFlags) {
        this.flags = Object.keys(value.redFlags)
      }
    }
  },
  mounted () {
    if (this.estimate.redFlags) {
      this.flags = Object.keys(this.estimate.redFlags)
    }
  },
  methods: {
    manageRedFlags () {
      this.$router.push({ name: 'estimateRedFlags' })
    },
    redFlag (id) {
      const flag = this.$store.getters.redFlag(id)
      return flag.title
    }
  }
}
</script>
